import React, { useEffect, useRef } from "react";
import { Box } from "@chakra-ui/react";
import { CtaButtons } from "components/header/cta-buttons";
import { LogoPopover } from "components/header/logo-popover";
import { Container } from "ui/container";
import { remCalc } from "theme/utils";
import { useColorTheme } from "contexts/color-theme";
import { useHeaderHeight } from "contexts/header-height";

export function HeaderSimple() {
  const { bgColor } = useColorTheme();
  const headerHeight = remCalc(92);
  const headerRef = useRef<HTMLDivElement>(null);
  const { setHeaderHeight } = useHeaderHeight();

  // @TODO(lrhacker): extract this into a hook between this and the full header.
  // It needs to support setting width for the full header, so some additional refactor work needed.
  useEffect(() => {
    const headerObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeaderHeight(entry.contentRect.height);
      }
    });

    if (headerRef.current) {
      headerObserver.observe(headerRef.current);
    }

    return () => {
      headerObserver.disconnect();
    };
  }, [setHeaderHeight]);

  return (
    <Box ref={headerRef} as="header" bg={bgColor} layerStyle="header">
      <Container display="flex" alignItems="center" height={headerHeight} justifyContent="space-between">
        <LogoPopover />

        <CtaButtons hasLogin={false} />
      </Container>
    </Box>
  );
}
